import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  assistantDetails: {
    assistant: {
      actions: [],
      prompt_suggestions: [],
      initial_prompts: [],
    },
  },
}

const assistantsStore = createSlice({
  name: "swayamAssistants",
  initialState,
  reducers: {
    setAssistantDetails: (state, action) => ({
      ...state,
      assistantDetails: action.payload,
    }),
    resetAssistantDetails: () => initialState,
  },
})

export const { setAssistantDetails, resetAssistantDetails } = assistantsStore.actions

export default assistantsStore.reducer
